import { TRPCClientError } from "@trpc/client";
import { type typeToFlattenedError } from "zod";

import type { AppRouter } from "@trip/api";

export function isTRPCClientError(
  cause: unknown,
): cause is TRPCClientError<AppRouter> {
  return cause instanceof TRPCClientError;
}

function convertErrors(input: typeToFlattenedError<unknown[], string>) {
  const result: { message: string; field?: string }[] = [];

  // Add formErrors to result as general messages
  input.formErrors.forEach((error) => {
    result.push({ message: error });
  });

  // Add fieldErrors to result with associated field
  for (const field in input.fieldErrors) {
    const errors = input.fieldErrors[field];
    if (errors) {
      errors.forEach((error) => {
        result.push({ message: error, field });
      });
    }
  }

  return result;
}

export function getTRPCInputErrors(error: TRPCClientError<AppRouter>) {
  if (error.data && "zodError" in error.data && error.data.zodError) {
    const err = error.data.zodError as typeToFlattenedError<unknown[], string>;
    return convertErrors(err);
  }
  return [];
}
